<cov-icon [iconName]="iconName"></cov-icon>
<div class="cov-toast-message-area">
  @if (title) {
    <h4 class="cov-toast-title" [class]="options.titleClass" [attr.aria-label]="title">
      {{ title }}
      @if (duplicatesCount) {
        [{{ duplicatesCount + 1 }}]
      }
    </h4>
  }
  @if (message && options.enableHtml) {
    <div role="alert" [class]="options.messageClass" [innerHTML]="message"></div>
  }
  @if (message && !options.enableHtml) {
    <div role="alert" [class]="options.messageClass" [attr.aria-label]="message">
      {{ message }}
    </div>
  }
</div>
@if (options.closeButton) {
  <button class="cov-toast-button" (click)="remove()" type="button" aria-label="Close">
    <cov-icon [iconName]="IconName.CLOSE"></cov-icon>
  </button>
}
@if (options.progressBar) {
  <div class="toast-progress" [ngClass]="progressBarCss" [style.width]="width() + '%'"></div>
}
